import { LegalPage } from './legal-page'

const sections = [
  {
    heading: 'Термины и определения',
    body: [
      'Для целей настоящего Пользовательского соглашения используются следующие термины: Сайт, Пользователь, Профиль, Персональная информация Пользователя, Информация, База данных и Подписка.',
      'Под Сайтом понимается интернет-ресурс Epic Growth, включая программное обеспечение, интерфейсы, дизайн, базу данных, разделы и размещенную информацию на доменах http://epicgrowth.io, https://my.epicgrowth.io, https://lk.epicgrowth.io и https://egconf.io.',
      'Пользователь — лицо, прошедшее регистрацию и/или авторизацию, а также любое лицо, фактически использующее сайт и его функции.',
    ],
  },
  {
    heading: 'Предмет и общие положения',
    body: [
      'Настоящее соглашение регулирует порядок использования сайта, условия доступа к контенту и дополнительные функции платформы.',
      'Используя сайт, пользователь подтверждает согласие с условиями настоящего соглашения и обязуется соблюдать применимое законодательство.',
      'Администрация сайта вправе обновлять условия соглашения. Новая редакция вступает в силу с момента публикации на сайте, если иное не предусмотрено самой редакцией.',
    ],
  },
  {
    heading: 'Доступ к контенту и подписке',
    body: [
      'Сайт может предоставлять ограниченный или неограниченный по времени доступ к единицам контента, а также доступ по модели подписки в соответствии с выбранным тарифом.',
      'Оплата доступа/подписки осуществляется безналичным способом. Пользователь подтверждает корректность введенных платежных данных и согласие с условиями оплаты.',
      'При отсутствии оплаты за очередной период подписки доступ к платному контенту может быть ограничен или прекращен до момента успешного списания.',
    ],
  },
  {
    heading: 'Персональные данные и коммуникации',
    body: [
      'Предоставляя персональные данные, пользователь дает согласие на их обработку в объеме, необходимом для функционирования сервиса, обратной связи и исполнения обязательств по соглашению.',
      'Пользователь вправе отозвать согласие на обработку персональных данных в порядке, предусмотренном применимым законодательством и политикой конфиденциальности.',
      'Связаться с администрацией по вопросам соглашения и обработки данных можно по адресу: ap@epicgrowth.io.',
    ],
  },
]

export function UserAgreementPage() {
  return <LegalPage title="Пользовательское соглашение" sections={sections} />
}
